import { message, Table, DatePicker, Card, Row, Col, Select, Descriptions, Input, Space, Tag, Dropdown } from "antd"
import { useWallet } from "../../Context/Walletcontext"
import { Userauthcontexthooks } from "../../Hooks/Userauthcontexthooks"
import Topnavbar from "../../Layouts/Topnavbar"
import { Container, Title, Text, Paper, TextInput, Grid, Button, Group, Modal, Stack, Badge, Divider, PinInput, Tabs, Drawer } from "@mantine/core"
import { useEffect, useState } from "react"
import { Get_Payout_History, Get_Saved_Beneficiary, Make_payout_request, Verify_bank_penny_drop_request } from "../../apicall"
import Paymentloader from "../../Loader/Paymentloader"
import { IconInfoCircle, IconCheck, IconCashBanknote, IconExclamationCircle, IconClock, IconReceiptRefund } from "@tabler/icons-react"
import dayjs from "dayjs";






const Payout = ({ Headername }) => {

    const columns = [
        {
            title: "Customer Details",
            key: "customerDetails",
            render: (_, record) => {

                const bene = record?.responsePayload || {};

                return (
                    <div>
                        <div style={{ fontWeight: 600 }}>
                            {bene?.beneName || "N/A"}
                        </div>

                        <div style={{ fontSize: 13, marginTop: 3 }}>
                            A/C: {bene?.beneAccountNumber || "N/A"}
                        </div>

                        <div style={{ fontSize: 13, marginTop: 2 }}>
                            IFSC: {bene?.beneIFSC || "N/A"}
                        </div>
                    </div>
                );
            },
        },

        {
            title: "Pay Again",
            key: "payAgain",
            align: "center",
            width: 130,
            render: (_, record) => {

                const bene = record?.responsePayload || {};

                return (
                    <Button
                        type="primary"
                        size="small"
                        onClick={() => handlePayAgain(bene)}
                    >
                        Pay Again
                    </Button>
                );
            },
        },
    ];
    const payoutcolumns = [
        {
            title: "Date & Time",
            key: "createdAt",
            width: 170,
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 600 }}>
                        {dayjs(record?.createdAt).format("DD MMM YYYY")}
                    </div>

                    <div style={{ fontSize: 12, color: "#888" }}>
                        {dayjs(record?.createdAt).format("hh:mm A")}
                    </div>
                </div>
            ),
        },

        {
            title: "Transaction",
            key: "transaction",
            width: 240,
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 600 }}>
                        {record?.requestID || "N/A"}
                    </div>

                    <div style={{ fontSize: 12, color: "#888" }}>
                        UTR: {record?.responsePayload?.utr || "N/A"}
                    </div>
                </div>
            ),
        },

        {
            title: "Beneficiary",
            key: "beneficiary",
            width: 220,
            render: (_, record) => {
                const payload = record?.requestPayload || {};

                return (
                    <div>
                        <div style={{ fontWeight: 600 }}>
                            {payload?.custName || "N/A"}
                        </div>

                        <div style={{ fontSize: 12 }}>
                            A/C: {payload?.custAccountNumber || "N/A"}
                        </div>

                        <div style={{ fontSize: 12, color: "#888" }}>
                            {payload?.custIFSC || "N/A"}
                        </div>
                    </div>
                );
            },
        },

        {
            title: "Amount",
            key: "amount",
            align: "right",
            width: 130,
            render: (_, record) => (
                <span style={{ fontWeight: 600 }}>
                    ₹{" "}
                    {Number(
                        record?.requestPayload?.transferAmount || 0
                    ).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                    })}
                </span>
            ),
        },

        {
            title: "Type",
            key: "transferType",
            width: 100,
            render: (_, record) => (
                <Tag>
                    {record?.requestPayload?.transferType || "N/A"}
                </Tag>
            ),
        },

        {
            title: "Status",
            key: "status",
            width: 120,
            render: (_, record) => getStatusTag(record),
        },

        {
            title: "Action",
            key: "action",
            width: 100,
            fixed: "right",
            align: "center",
            render: (_, record) => (
                <Dropdown
                    menu={{
                        items: getActionItems(record),
                        onClick: (event) =>
                            handleAction(event, record),
                    }}
                    trigger={["click"]}
                >
                    <Button size="xs" variant="outline">
                        Action
                    </Button>
                </Dropdown>
            ),
        },
    ];
    const today = dayjs();
    const [dateRange, setDateRange] = useState([
        today.startOf("day"),
        today.endOf("day"),
    ]);

    const { user } = Userauthcontexthooks();
    const { refreshWallet } = useWallet();
    const [transferInputs, setTransferInputs] = useState({
        custIFSC: '',
        custAccountNumber: '',
        custName: '',
        custMobileNumber: '',
        transferAmount: '',
        transferType: 'IMPS',
        transferPurpose: '',
    })
    const [beneDetails, setBenedetails] = useState('');
    const [beneVerified, setBeneVerified] = useState(false);
    const [mpin, setMpin] = useState("");
    const [mpinModal, setMpinModal] = useState(false);
    const [transferLoading, setTransferLoading] = useState(false);
    const [verifydetailsLoading, setVerifyLoading] = useState(false);
    const [fetchbene, setfetchbene] = useState(true);
    const [savedBeneficiaries, setSavedBeneficiaries] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
    });
    const [activeTab, setActiveTab] = useState("payment");

    const [beneficiarySearch, setBeneficiarySearch] = useState("");

    const [payouthistoryloading, setPayouthistoryloading] = useState(true);
    const [allPayouthistories, setAllpayouthistories] = useState([]);
    const [filteredpayouthistories, setfilteredpayouthistories] = useState([]);

    const [status, setStatus] = useState("ALL");
    const [searchTxn, setSearchTxn] = useState("");

    const [selectedPayout, setSelectedPayout] = useState(null);
    const [payoutDrawerOpen, setPayoutDrawerOpen] = useState(false);

    const [receiptOpen, setReceiptOpen] = useState(false);
    const [receiptData, setReceiptData] = useState(null);

    // for beneficiaries
    const filteredBeneficiaries = savedBeneficiaries.filter((record) => {
        const accountNumber = record?.responsePayload?.beneAccountNumber || "";

        return accountNumber
            .toLowerCase()
            .includes(beneficiarySearch.trim().toLowerCase());
    });

    // for payout filter histories
    const applyPayoutFilters = () => {
        let data = [...allPayouthistories];

        // STATUS
        if (status !== "ALL") {
            data = data.filter((item) => {
                const currentStatus =
                    item?.responsePayload?.reqStatus ||
                    item?.providerStatus ||
                    "";

                return currentStatus.toUpperCase() === status;
            });
        }

        // SEARCH
        const search = searchTxn.trim().toLowerCase();

        if (search) {
            data = data.filter((item) => {
                const requestID =
                    item?.requestID || "";

                const responseID =
                    item?.responseID || "";

                const providerTransactionID =
                    item?.providerTransactionID || "";

                const providerClientTransactionID =
                    item?.providerClientTransactionID || "";

                const utr =
                    item?.responsePayload?.utr || "";

                const accountNumber =
                    item?.requestPayload?.custAccountNumber || "";

                return (
                    requestID.toLowerCase().includes(search) ||
                    responseID.toLowerCase().includes(search) ||
                    providerTransactionID.toLowerCase().includes(search) ||
                    providerClientTransactionID.toLowerCase().includes(search) ||
                    utr.toLowerCase().includes(search) ||
                    accountNumber.toLowerCase().includes(search)
                );
            });
        }

        setfilteredpayouthistories(data);
    };

    const getPayoutStatus = (record) => {
        return (
            record?.responsePayload?.reqStatus ||
            record?.providerStatus ||
            "UNKNOWN"
        ).toUpperCase();
    };

    const getStatusTag = (record) => {
        const currentStatus = getPayoutStatus(record);

        switch (currentStatus) {
            case "SUCCESS":
            case "SUCCESSFUL":
            case "COMPLETED":
                return <Tag color="green">SUCCESS</Tag>;

            case "PENDING":
                return <Tag color="orange">PENDING</Tag>;

            case "FAILED":
            case "FAILURE":
            case "REJECTED":
                return <Tag color="red">FAILED</Tag>;

            case "REFUND":
            case "REFUNDED":
                return <Tag color="blue">REFUND</Tag>;

            default:
                return <Tag>{currentStatus}</Tag>;
        }
    };

    const handleAction = ({ key }, record) => {
        switch (key) {
            case "receipt":
                handleReceipt(record);
                break;

            case "refund":
                handleRefundInitiate(record);
                break;

            case "details":
                setSelectedPayout(record);
                setPayoutDrawerOpen(true);
                break;

            default:
                break;
        }
    };

    const handleReceipt = (record) => {
        setReceiptData(record);
        setReceiptOpen(true);
    };

    const ReceiptRow = ({ label, value }) => (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: 20,
                fontSize: 13,
            }}
        >
            <span
                style={{
                    color: "#777",
                    flexShrink: 0,
                }}
            >
                {label}
            </span>

            <span
                style={{
                    fontWeight: 600,
                    textAlign: "right",
                    wordBreak: "break-word",
                }}
            >
                {value}
            </span>
        </div>
    );

    const handlePrintReceipt = () => {
        const receipt = document.getElementById("payout-receipt");

        if (!receipt) return;

        const printWindow = window.open(
            "",
            "_blank",
            "width=500,height=700"
        );

        printWindow.document.write(`
            <!DOCTYPE html>
            <html>
                <head>
                    <style>
                        * {
                            box-sizing: border-box;
                        }
    
                        body {
                            margin: 0;
                            padding: 20px;
                            background: #fff;
                            font-family: Arial, sans-serif;
                        }
    
                        @media print {
                            body {
                                padding: 0;
                            }
    
                            @page {
                                size: auto;
                                margin: 10mm;
                            }
                        }
                    </style>
                </head>
    
                <body>
                    ${receipt.outerHTML}
                </body>
            </html>
        `);

        printWindow.document.close();
        printWindow.focus();

        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 300);
    };

    const handleRefundInitiate = (record) => {
        console.log("Refund initiate:", record);
    };

    const getActionItems = (record) => {
        const currentStatus = getPayoutStatus(record);

        const isFailed = [
            "FAILED",
            "FAILURE",
            "REJECTED",
        ].includes(currentStatus);

        return [
            {
                key: "receipt",
                label: "Receipt",
            },
            ...(isFailed
                ? [
                    {
                        key: "refund",
                        label: "Refund Initiate",
                    },
                ]
                : []),
            {
                key: "details",
                label: "More Details",
            },
        ];
    };

    const handleTransferInputChange = (event) => {
        const { name, value } = event.currentTarget;

        setTransferInputs((prev) => ({
            ...prev,
            [name]:
                name === "custIFSC"
                    ? value.toUpperCase()
                    : value
        }));
    };

    const handleTransferSubmit = () => {

        const { custIFSC, custAccountNumber, custName, custMobileNumber, transferAmount, transferType } = transferInputs;
        //console.log("Transfer inputs", transferInputs);


        if (!custIFSC || !custAccountNumber || !custName || !custMobileNumber || !transferAmount || !transferType) {
            message.error('custIFSC, custAccountNumber, custName, custMobileNumber, transferAmount. is required');
            return;
        }

        if (transferAmount === '' || isNaN(transferAmount) || parseFloat(transferAmount) < 100) {
            message.error('Please enter a valid transfer amount- minimun amount should be ₹100.');
            return;
        }

        if (custMobileNumber.length > 10 || custMobileNumber.length < 10) {
            message.error('Please enter a valid 10 digit mobile number.');
            return;
        }


        // call the mpin modal
        setMpinModal(true);
    }

    const fetchpayouthistory = async () => {
        try {
            const data = await Get_Payout_History(
                dateRange[0].format("YYYY-MM-DD"),
                dateRange[1].format("YYYY-MM-DD")
            )
            // console.log("payout histories:", data);

            if (data.success) {
                setAllpayouthistories(data?.payoutRequests);
                setfilteredpayouthistories(data?.payoutRequests);
            }

        } catch (error) {
            message.error(error.response?.data?.message || "Something went wrong.");
        } finally {
            setPayouthistoryloading(false);
        }
    }

    const confirmTransfer = async () => {

        const { custIFSC, custAccountNumber, custName, custMobileNumber, transferAmount, transferType } = transferInputs;

        if (!custIFSC || !custAccountNumber || !custName || !custMobileNumber || !transferAmount || !transferType) {
            message.error('custIFSC, custAccountNumber, custName, custMobileNumber, transferAmount. is required');
            return;
        }

        if (transferAmount === '' || isNaN(transferAmount) || parseFloat(transferAmount) < 100) {
            message.error('Please enter a valid transfer amount- minimun amount should be ₹100.');
            return;
        }

        if (custMobileNumber.length > 10 || custMobileNumber.length < 10) {
            message.error('Please enter a valid 10 digit mobile number.');
            return;
        }

        try {
            setTransferLoading(true);

            // Wait until location is available
            const position = await new Promise((resolve, reject) => {
                navigator.geolocation.getCurrentPosition(
                    resolve,
                    reject,
                    {
                        enableHighAccuracy: true,
                        timeout: 15000,
                        maximumAge: 0
                    }
                );
            });

            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;

            // Make sure we actually received coordinates
            if (latitude === undefined || latitude === null || longitude === undefined || longitude === null) {
                message.error('Unable to get your current location.');
                return;
            }
            const body = {
                custIFSC: custIFSC,
                custAccountNumber: custAccountNumber,
                custName: custName,
                custMobileNumber: custMobileNumber,
                transferAmount: transferAmount,
                transferType: transferType,
                latitude,
                longitude,
                mpin: mpin
            }
            const data = await Make_payout_request(body);

            //console.log("Payment response:", data);
            if (data.success) {
                message.success(data.message);
                setBeneVerified(false);
                setBenedetails('');
                setTransferInputs({
                    custIFSC: '',
                    custAccountNumber: '',
                    custName: '',
                    custMobileNumber: '',
                    transferAmount: '',
                    transferType: 'IMPS',
                    transferPurpose: '',
                })
                setMpin('');
                await refreshWallet(); // update the wallet in real time. 
                setMpinModal(false);
                fetchpayouthistory();
                return;
            }

        } catch (error) {
            message.error(error.response?.data?.message || "Something went wrong.");
        } finally {
            setTransferLoading(false);
        }

    }

    const handelBankverifiy = async () => {
        const { custIFSC, custAccountNumber } = transferInputs;

        if (!custIFSC || !custAccountNumber) {
            message.error('custIFSC, custAccountNumber. is required');
            return;
        }
        setVerifyLoading(true);
        const body = {
            custIFSC: transferInputs?.custIFSC,
            custAccountNumber: transferInputs?.custAccountNumber,
            verificationType: 'IMPS_PENNY_DROP'
        }
        try {
            const data = await Verify_bank_penny_drop_request(body);

            console.log("Bank verification response:", data);
            if (data.success) {
                message.success(data.message);
                setBeneVerified(true);
                setBenedetails(data?.data)
                setTransferInputs((prev) => ({
                    ...prev,
                    custName: data?.data?.beneName || ""
                }));
                await refreshWallet(); // update the wallet in real time. 
            } else {
                setBeneVerified(false);
                setBenedetails(null);
                setTransferInputs((prev) => ({
                    ...prev,
                    custName: ""
                }));
            }

        } catch (error) {
            message.error(error.response?.data?.message || "Something went wrong.");
            setBeneVerified(false);
            setBenedetails(null);
            setTransferInputs((prev) => ({
                ...prev,
                custName: ""
            }));
        } finally {
            setVerifyLoading(false);
        }
    }

    const Getbene = async (page = 1, pageSize = 10) => {
        try {
            const data = await Get_Saved_Beneficiary(page, pageSize);
            console.log("Bene lists:", data);

            if (data?.success) {

                const uniqueBeneficiaries = [];
                const seen = new Set();

                for (const item of data?.beneficiary || []) {

                    const bene = item?.responsePayload || {};

                    const account = String(bene?.beneAccountNumber || "").trim();

                    const ifsc = String(bene?.beneIFSC || "").trim().toUpperCase();

                    const uniqueKey = `${account}_${ifsc}`;

                    if (!account || !ifsc) {
                        continue;
                    }

                    if (!seen.has(uniqueKey)) {

                        seen.add(uniqueKey);

                        uniqueBeneficiaries.push(item);
                    }
                }

                setSavedBeneficiaries(
                    uniqueBeneficiaries
                );

                setPagination({
                    current: data?.pagination?.current,
                    pageSize: data?.pagination?.pageSize,
                    total: data?.pagination?.total,
                });
            }
        } catch (error) {
            console.log(error);
            message.error(error.response?.data?.message || "Something went wrong.");
        } finally {
            setfetchbene(false);
        }
    }

    const handlePayAgain = (bene) => {

        setTransferInputs((prev) => ({
            ...prev,

            custAccountNumber: bene?.beneAccountNumber || "",

            custIFSC: bene?.beneIFSC || "",

            beneName: bene?.beneName || "",
        }));
        if (bene?.beneName) {
            setBeneVerified(true)
            setBenedetails(bene)
            setTransferInputs((prev) => ({
                ...prev,
                custName: bene?.beneName || ""
            }));
        } else {
            setBeneVerified(false)
            setBenedetails('')
            setTransferInputs((prev) => ({
                ...prev,
                custName: ""
            }));
        }
        // Go back to Payment screen
        setActiveTab("payment");

        // Optional: scroll to payment form
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };



    useEffect(() => {

        const Getbene = async (page = 1, pageSize = 10) => {
            try {
                const data = await Get_Saved_Beneficiary(page, pageSize);
                //console.log("Bene lists:", data);

                if (data?.success) {

                    const uniqueBeneficiaries = [];
                    const seen = new Set();

                    for (const item of data?.beneficiary || []) {

                        const bene = item?.responsePayload || {};

                        const account = String(bene?.beneAccountNumber || "").trim();

                        const ifsc = String(bene?.beneIFSC || "").trim().toUpperCase();

                        const uniqueKey = `${account}_${ifsc}`;

                        if (!account || !ifsc) {
                            continue;
                        }

                        if (!seen.has(uniqueKey)) {

                            seen.add(uniqueKey);

                            uniqueBeneficiaries.push(item);
                        }
                    }

                    setSavedBeneficiaries(
                        uniqueBeneficiaries
                    );

                    setPagination({
                        current: data?.pagination?.current,
                        pageSize: data?.pagination?.pageSize,
                        total: data?.pagination?.total,
                    });
                }
            } catch (error) {
                console.log(error);
                message.error(error.response?.data?.message || "Something went wrong.");
            } finally {
                setfetchbene(false);
            }
        }
        const fetchpayouthistory = async () => {
            try {
                const data = await Get_Payout_History(
                    dateRange[0].format("YYYY-MM-DD"),
                    dateRange[1].format("YYYY-MM-DD")
                )
                // console.log("payout histories:", data);

                if (data.success) {
                    setAllpayouthistories(data?.payoutRequests);
                    setfilteredpayouthistories(data?.payoutRequests);
                }

            } catch (error) {
                message.error(error.response?.data?.message || "Something went wrong.");
            } finally {
                setPayouthistoryloading(false);
            }
        }

        if (user) {
            Getbene();
            fetchpayouthistory();
        }

    }, [user, dateRange])

    useEffect(() => {
        applyPayoutFilters();
    }, [allPayouthistories, status, searchTxn]);
    return (
        <>
            <Topnavbar Headername={Headername} />

            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Payment Transfer</Title>
                <Text size="xs">You can transfer payments to beneficiary.</Text>
            </Container>

            <Container size={'lg'} mt={'lg'} p={'lg'}>
                <Tabs defaultValue="payment" variant="pills" radius={'lg'} value={activeTab} onChange={setActiveTab} mb={'md'}>
                    <Tabs.List>
                        <Tabs.Tab value="payment">
                            Payment screen
                        </Tabs.Tab>
                        <Tabs.Tab value="savedbene">
                            Saved customers
                        </Tabs.Tab>
                    </Tabs.List>

                    <Tabs.Panel value="payment">
                        <Grid>
                            <Grid.Col span={{ xs: 12, sm: 12, md: 6 }}>
                                <Paper shadow="sm" p={'xs'} mt={'sm'}>
                                    {/* <Group justify="flex-end"><Button size="xs">Add Beneficiary</Button></Group> */}
                                    <TextInput label="Payment Amount" placeholder="₹0.00" size="md" withAsterisk mt={'xs'} name="transferAmount" value={transferInputs.transferAmount} onChange={handleTransferInputChange} />
                                    <TextInput label="Customer Mobile Number" placeholder="999999999" size="md" withAsterisk mt={'xs'} name="custMobileNumber" value={transferInputs.custMobileNumber} onChange={handleTransferInputChange} maxLength={10} />
                                    <TextInput label="Customer IFSC" placeholder="KKBK0001234" size="md" withAsterisk mt={'xs'} name="custIFSC" value={transferInputs.custIFSC} onChange={handleTransferInputChange} />
                                    <TextInput label="Customer Account Number" placeholder="1122334455667788" size="md" withAsterisk mt={'xs'} name="custAccountNumber" value={transferInputs.custAccountNumber} onChange={handleTransferInputChange} rightSectionWidth={90} rightSection={<Button size="xs" variant="light" onClick={handelBankverifiy} loading={verifydetailsLoading}>Verify</Button>} />
                                    {(beneVerified || beneDetails) && (
                                        <TextInput
                                            label={
                                                beneVerified
                                                    ? "Beneficiary Name (Verified)"
                                                    : "Beneficiary Name (Enter Manually)"
                                            }
                                            placeholder="Mr. Joker"
                                            size="md"
                                            withAsterisk
                                            mt="xs"
                                            name="beneName"
                                            value={transferInputs?.custName || ""}
                                            onChange={handleTransferInputChange}
                                        />
                                    )}

                                    <Button fullWidth variant="light" size="md" mt={'md'} onClick={handleTransferSubmit} disabled={verifydetailsLoading}>Transfer Amount</Button>
                                </Paper>
                            </Grid.Col>

                            <Grid.Col span={{ xs: 12, sm: 12, md: 6 }}>
                                <Card
                                    title={
                                        <Space>
                                            <IconInfoCircle />
                                            <span>Payment Guidelines</span>
                                        </Space>
                                    }
                                    size="small"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                    styles={{
                                        body: {
                                            padding: 14,
                                        },
                                    }}
                                >
                                    <Space
                                        direction="vertical"
                                        size={10}
                                        style={{ width: "100%" }}
                                    >
                                        {/* Amount + Processing */}
                                        <Row gutter={10}>
                                            <Col span={12}>
                                                <div
                                                    style={{
                                                        background: "#f6f8fa",
                                                        borderRadius: 8,
                                                        padding: "10px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: 11,
                                                            color: "#888",
                                                        }}
                                                    >
                                                        Per Transaction
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: 15,
                                                            fontWeight: 700,
                                                            marginTop: 3,
                                                        }}
                                                    >
                                                        ₹100 – ₹99,999
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col span={12}>
                                                <div
                                                    style={{
                                                        background: "#f6f8fa",
                                                        borderRadius: 8,
                                                        padding: "10px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: 11,
                                                            color: "#888",
                                                        }}
                                                    >
                                                        Normal Processing
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: 15,
                                                            fontWeight: 700,
                                                            marginTop: 3,
                                                        }}
                                                    >
                                                        ~5 Seconds
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Guidelines */}
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <IconCheck
                                                style={{
                                                    color: "#16a34a",
                                                    marginTop: 3,
                                                }}
                                            />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Verify Beneficiary
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#777",
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    Check account number and IFSC before payment.
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <IconCashBanknote
                                                style={{
                                                    color: "#1677ff",
                                                    marginTop: 3,
                                                }}
                                            />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Bank Dependent
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#777",
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    Status depends on sender bank, beneficiary bank
                                                    and banking network responses.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Failed transaction warning */}
                                        <div
                                            style={{
                                                background: "#fff7e6",
                                                border: "1px solid #ffd591",
                                                borderRadius: 8,
                                                padding: 11,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: 8,
                                                    alignItems: "flex-start",
                                                }}
                                            >
                                                <IconExclamationCircle
                                                    style={{
                                                        color: "#fa8c16",
                                                        marginTop: 2,
                                                    }}
                                                />

                                                <div>
                                                    <div
                                                        style={{
                                                            fontSize: 13,
                                                            fontWeight: 700,
                                                            color: "#ad6800",
                                                        }}
                                                    >
                                                        Failed Transaction?
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: 12,
                                                            color: "#8c6b32",
                                                            lineHeight: 1.45,
                                                            marginTop: 3,
                                                        }}
                                                    >
                                                        A failed status may require bank
                                                        reconciliation. Check the latest status
                                                        before retrying to avoid duplicate payment.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Waiting time */}
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <IconClock
                                                style={{
                                                    color: "#722ed1",
                                                    marginTop: 3,
                                                }}
                                            />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Status Update
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#777",
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    Normally allow 1–2 hours. Exceptional cases may
                                                    take 1–3 business days.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Refund */}
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <IconReceiptRefund
                                                style={{
                                                    color: "#eb2f96",
                                                    marginTop: 3,
                                                }}
                                            />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Refund Request
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#777",
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    For eligible failed transactions, use
                                                    <b> Action → Refund Initiate</b>.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Service time */}
                                        <Divider style={{ margin: "2px 0" }} />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#777",
                                                }}
                                            >
                                                Payment Service
                                            </span>

                                            <Tag
                                                color="green"
                                                style={{ margin: 0 }}
                                            >
                                                08:00 AM – 11:00 PM
                                            </Tag>
                                        </div>

                                        {/* Footer */}
                                        <div
                                            style={{
                                                fontSize: 11,
                                                color: "#999",
                                                lineHeight: 1.4,
                                                textAlign: "center",
                                                paddingTop: 2,
                                            }}
                                        >
                                            Our platform acts as a technology bridge between
                                            connected banking systems. Transaction processing
                                            depends on bank and network responses.
                                        </div>
                                    </Space>
                                </Card>
                            </Grid.Col>
                        </Grid>
                    </Tabs.Panel>

                    <Tabs.Panel value="savedbene">
                        <Grid mt={'sm'}>
                            <Grid.Col span={{ xs: 12, sm: 12, md: 6 }}>
                                <TextInput
                                    placeholder="Search by account number"
                                    allowClear
                                    size="xs"
                                    value={beneficiarySearch}
                                    onChange={(e) => setBeneficiarySearch(e.target.value)}
                                    p={'sm'}
                                // style={{ width: 320, marginBottom: 16 }}
                                />
                                <div style={{ width: "100%", overflowX: "auto" }}>
                                    <Table
                                        columns={columns}
                                        dataSource={filteredBeneficiaries}
                                        loading={fetchbene}
                                        bordered
                                        size="middle"
                                        rowKey="_id"
                                        pagination={pagination}
                                        onChange={(page) => {
                                            Getbene(page.current, page.pageSize);
                                            setfetchbene(true)
                                        }}
                                    />
                                </div>
                            </Grid.Col>
                            <Grid.Col span={{ xs: 12, sm: 12, md: 6 }}>
                                <Card
                                    title={
                                        <Space>
                                            <IconInfoCircle />
                                            <span>Payment Guidelines</span>
                                        </Space>
                                    }
                                    size="small"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                    }}
                                    styles={{
                                        body: {
                                            padding: 14,
                                        },
                                    }}
                                >
                                    <Space
                                        direction="vertical"
                                        size={10}
                                        style={{ width: "100%" }}
                                    >
                                        {/* Amount + Processing */}
                                        <Row gutter={10}>
                                            <Col span={12}>
                                                <div
                                                    style={{
                                                        background: "#f6f8fa",
                                                        borderRadius: 8,
                                                        padding: "10px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: 11,
                                                            color: "#888",
                                                        }}
                                                    >
                                                        Per Transaction
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: 15,
                                                            fontWeight: 700,
                                                            marginTop: 3,
                                                        }}
                                                    >
                                                        ₹100 – ₹99,999
                                                    </div>
                                                </div>
                                            </Col>

                                            <Col span={12}>
                                                <div
                                                    style={{
                                                        background: "#f6f8fa",
                                                        borderRadius: 8,
                                                        padding: "10px",
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            fontSize: 11,
                                                            color: "#888",
                                                        }}
                                                    >
                                                        Normal Processing
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: 15,
                                                            fontWeight: 700,
                                                            marginTop: 3,
                                                        }}
                                                    >
                                                        ~5 Seconds
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* Guidelines */}
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <IconCheck
                                                style={{
                                                    color: "#16a34a",
                                                    marginTop: 3,
                                                }}
                                            />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Verify Beneficiary
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#777",
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    Check account number and IFSC before payment.
                                                </div>
                                            </div>
                                        </div>

                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <IconCashBanknote
                                                style={{
                                                    color: "#1677ff",
                                                    marginTop: 3,
                                                }}
                                            />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Bank Dependent
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#777",
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    Status depends on sender bank, beneficiary bank
                                                    and banking network responses.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Failed transaction warning */}
                                        <div
                                            style={{
                                                background: "#fff7e6",
                                                border: "1px solid #ffd591",
                                                borderRadius: 8,
                                                padding: 11,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: 8,
                                                    alignItems: "flex-start",
                                                }}
                                            >
                                                <IconExclamationCircle
                                                    style={{
                                                        color: "#fa8c16",
                                                        marginTop: 2,
                                                    }}
                                                />

                                                <div>
                                                    <div
                                                        style={{
                                                            fontSize: 13,
                                                            fontWeight: 700,
                                                            color: "#ad6800",
                                                        }}
                                                    >
                                                        Failed Transaction?
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: 12,
                                                            color: "#8c6b32",
                                                            lineHeight: 1.45,
                                                            marginTop: 3,
                                                        }}
                                                    >
                                                        A failed status may require bank
                                                        reconciliation. Check the latest status
                                                        before retrying to avoid duplicate payment.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Waiting time */}
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <IconClock
                                                style={{
                                                    color: "#722ed1",
                                                    marginTop: 3,
                                                }}
                                            />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Status Update
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#777",
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    Normally allow 1–2 hours. Exceptional cases may
                                                    take 1–3 business days.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Refund */}
                                        <div
                                            style={{
                                                display: "flex",
                                                gap: 10,
                                                alignItems: "flex-start",
                                            }}
                                        >
                                            <IconReceiptRefund
                                                style={{
                                                    color: "#eb2f96",
                                                    marginTop: 3,
                                                }}
                                            />

                                            <div>
                                                <div
                                                    style={{
                                                        fontSize: 13,
                                                        fontWeight: 600,
                                                    }}
                                                >
                                                    Refund Request
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: 12,
                                                        color: "#777",
                                                        lineHeight: 1.4,
                                                    }}
                                                >
                                                    For eligible failed transactions, use
                                                    <b> Action → Refund Initiate</b>.
                                                </div>
                                            </div>
                                        </div>

                                        {/* Service time */}
                                        <Divider style={{ margin: "2px 0" }} />

                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                            }}
                                        >
                                            <span
                                                style={{
                                                    fontSize: 12,
                                                    color: "#777",
                                                }}
                                            >
                                                Payment Service
                                            </span>

                                            <Tag
                                                color="green"
                                                style={{ margin: 0 }}
                                            >
                                                08:00 AM – 11:00 PM
                                            </Tag>
                                        </div>

                                        {/* Footer */}
                                        <div
                                            style={{
                                                fontSize: 11,
                                                color: "#999",
                                                lineHeight: 1.4,
                                                textAlign: "center",
                                                paddingTop: 2,
                                            }}
                                        >
                                            Our platform acts as a technology bridge between
                                            connected banking systems. Transaction processing
                                            depends on bank and network responses.
                                        </div>
                                    </Space>
                                </Card>
                            </Grid.Col>
                        </Grid>

                    </Tabs.Panel>
                </Tabs>

                <Card
                    title="Payment History"
                    style={{ width: "100%" }}
                >
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        <Col xs={24} md={8}>
                            <DatePicker.RangePicker
                                style={{ width: "100%" }}
                                value={dateRange}
                                onChange={(value) => {
                                    if (value) {
                                        setDateRange(value);
                                    }
                                }}
                                allowClear={false}
                            />
                        </Col>

                        <Col xs={24} md={4}>
                            <Select
                                value={status}
                                onChange={setStatus}
                                style={{ width: "100%" }}
                                options={[
                                    {
                                        label: "ALL",
                                        value: "ALL",
                                    },
                                    {
                                        label: "SUCCESS",
                                        value: "SUCCESS",
                                    },
                                    {
                                        label: "PENDING",
                                        value: "PENDING",
                                    },
                                    {
                                        label: "FAILED",
                                        value: "FAILED",
                                    },
                                    {
                                        label: "REFUND",
                                        value: "REFUND",
                                    },
                                ]}
                            />
                        </Col>

                        <Col xs={24} md={6}>
                            <Input.Search
                                placeholder="Search Transaction ID / UTR / Account"
                                allowClear
                                value={searchTxn}
                                onChange={(e) =>
                                    setSearchTxn(e.target.value)
                                }
                                onSearch={applyPayoutFilters}
                            />
                        </Col>

                        <Col xs={24} md={12}>
                            <Space wrap>
                                <Button
                                    type="primary"
                                    onClick={applyPayoutFilters}
                                >
                                    Search
                                </Button>

                                <Button
                                    variant="light"
                                    onClick={() => {
                                        setStatus("ALL");
                                        setSearchTxn("");
                                    }}
                                >
                                    Reset
                                </Button>

                                <Button variant="outline">
                                    Download
                                </Button>

                                <Button
                                    variant="outline"
                                    onClick={fetchpayouthistory}
                                >
                                    Refresh
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div
                        style={{
                            width: "100%",
                            overflowX: "auto",
                        }}
                    >
                        <Table
                            columns={payoutcolumns}
                            dataSource={filteredpayouthistories}
                            loading={payouthistoryloading}
                            bordered
                            size="middle"
                            rowKey="_id"
                            // scroll={{ x: 1100 }}
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                                showTotal: (total) =>
                                    `Total ${total} transactions`,
                            }}
                        />
                    </div>
                </Card>
            </Container >

            {/* Confirm Modal */}
            <Modal
                opened={mpinModal}
                onClose={() => setMpinModal(false)}
                title="Confirm Payment Transfer"
                centered
                radius="md"
                size="md"
            >

                <Stack>

                    <Paper withBorder p="md" radius="md">

                        <Stack gap={8}>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Customer Name
                                </Text>

                                <Text fw={600}>
                                    {transferInputs?.custName}
                                </Text>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Customer Account Number
                                </Text>

                                <Badge>
                                    {transferInputs?.custAccountNumber}
                                </Badge>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Customer Mobile
                                </Text>

                                <Text>
                                    {transferInputs?.custMobileNumber}
                                </Text>
                            </Group>

                            <Divider />

                            <Group justify="space-between">
                                <Text size="sm" fw={600}>
                                    Transfer Amount
                                </Text>

                                <Text
                                    fw={700}
                                    size="lg"
                                    c="green"
                                >
                                    ₹ {Number(transferInputs.transferAmount).toLocaleString()}
                                </Text>
                            </Group>

                            <Group justify="space-between">
                                <Text size="sm" c="dimmed">
                                    Remarks
                                </Text>

                                <Text>
                                    {transferInputs.remarks || "-"}
                                </Text>
                            </Group>

                        </Stack>

                    </Paper>

                    <Divider />

                    <Stack align="center">

                        <Text fw={600}>
                            Enter 6 Digit MPIN
                        </Text>

                        <PinInput
                            length={6}
                            oneTimeCode={false}
                            type="number"
                            value={mpin}
                            onChange={setMpin}
                            mask
                            size="lg"
                        />

                    </Stack>
                    {
                        transferLoading && (
                            <Paymentloader />
                        )
                    }

                    <Button
                        fullWidth
                        size="md"
                        loading={transferLoading}
                        onClick={confirmTransfer}
                    >
                        Confirm Transfer ₹ {Number(transferInputs.transferAmount).toLocaleString()}
                    </Button>

                </Stack>
            </Modal>

            {/* More detais drawer */}
            <Drawer
                title="Payout Transaction Details"
                placement="right"
                width={600}
                opened={payoutDrawerOpen}
                onClose={() => {
                    setPayoutDrawerOpen(false);
                    setSelectedPayout(null);
                }}
            >
                {selectedPayout && (
                    <>
                        <Descriptions
                            title="Transaction Information"
                            bordered
                            column={1}
                            size="small"
                            style={{ padding: '10px' }}
                        >
                            <Descriptions.Item label="Request ID">
                                {selectedPayout?.requestID || "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Response ID">
                                {selectedPayout?.responseID || "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Status">
                                {getStatusTag(selectedPayout)}
                            </Descriptions.Item>

                            <Descriptions.Item label="Created At">
                                {selectedPayout?.createdAt
                                    ? dayjs(selectedPayout.createdAt).format(
                                        "DD MMM YYYY hh:mm:ss A"
                                    )
                                    : "N/A"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Beneficiary Details"
                            bordered
                            column={1}
                            size="small"
                            style={{ padding: '10px' }}
                        >
                            <Descriptions.Item label="Name">
                                {selectedPayout?.requestPayload?.custName ||
                                    "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Account Number">
                                {selectedPayout?.requestPayload
                                    ?.custAccountNumber || "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="IFSC">
                                {selectedPayout?.requestPayload?.custIFSC ||
                                    "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Mobile">
                                {selectedPayout?.requestPayload
                                    ?.custMobileNumber || "N/A"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Payment Details"
                            bordered
                            column={1}
                            size="small"
                            style={{ padding: '10px' }}
                        >
                            <Descriptions.Item label="Amount">
                                ₹{" "}
                                {Number(
                                    selectedPayout?.requestPayload
                                        ?.transferAmount || 0
                                ).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                })}
                            </Descriptions.Item>

                            <Descriptions.Item label="Transfer Type">
                                {selectedPayout?.requestPayload?.transferType ||
                                    "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="UTR">
                                {selectedPayout?.responsePayload?.utr ||
                                    "N/A"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Transfer Purpose">
                                {selectedPayout?.requestPayload
                                    ?.transferPurpose || "N/A"}
                            </Descriptions.Item>
                        </Descriptions>

                        <Divider />

                        <Descriptions
                            title="Refund Information"
                            bordered
                            column={1}
                            size="small"
                            style={{ padding: '10px' }}
                        >
                            <Descriptions.Item label="Refund Required">
                                {selectedPayout?.refundRequired
                                    ? "Yes"
                                    : "No"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Refund Completed">
                                {selectedPayout?.refundCompleted
                                    ? "Yes"
                                    : "No"}
                            </Descriptions.Item>

                            <Descriptions.Item label="Refund Amount">
                                ₹{" "}
                                {Number(
                                    selectedPayout?.refundAmount || 0
                                ).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                })}
                            </Descriptions.Item>

                            <Descriptions.Item label="Refunded At">
                                {selectedPayout?.refundedAt
                                    ? dayjs(
                                        selectedPayout.refundedAt
                                    ).format("DD MMM YYYY hh:mm:ss A")
                                    : "N/A"}
                            </Descriptions.Item>
                        </Descriptions>
                    </>
                )}
            </Drawer>

            {/* Reciept modal */}
            <Modal
                title={' Payment Receipt '}
                opened={receiptOpen}
                onClose={() => {
                    setReceiptOpen(false);
                    setReceiptData(null);
                }}
                centered
                width={430}
                styles={{
                    body: {
                        padding: 0,
                    },
                }}
            >
                {receiptData && (
                    <div
                        id="payout-receipt"
                        style={{
                            background: "#fff",
                            padding: "28px 26px",
                            width: "100%",
                            color: "#111",
                        }}
                    >
                        {/* Header */}
                        <div
                            style={{
                                textAlign: "center",
                                // marginBottom: 22,
                            }}
                        >
                        </div>

                        {/* Status */}
                        <div
                            style={{
                                textAlign: "center",
                                // marginBottom: 22,
                            }}
                        >
                            {getPayoutStatus(receiptData) === "SUCCESS" ? (
                                <>
                                    <div
                                        style={{
                                            fontSize: 30,
                                            lineHeight: 1,
                                            marginBottom: 8,
                                        }}
                                    >
                                        ✓
                                    </div>

                                    <div
                                        style={{
                                            fontSize: 17,
                                            fontWeight: 700,
                                        }}
                                    >
                                        Payment Successful
                                    </div>
                                </>
                            ) : (
                                <div
                                    style={{
                                        fontSize: 17,
                                        fontWeight: 700,
                                    }}
                                >
                                    {getPayoutStatus(receiptData)}
                                </div>
                            )}
                        </div>

                        {/* Amount */}
                        <div
                            style={{
                                textAlign: "center",
                                marginBottom: 24,
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 12,
                                    color: "#777",
                                }}
                            >
                                Amount
                            </div>

                            <div
                                style={{
                                    fontSize: 30,
                                    fontWeight: 800,
                                    marginTop: 3,
                                }}
                            >
                                ₹{" "}
                                {Number(
                                    receiptData?.requestPayload?.transferAmount || 0
                                ).toLocaleString("en-IN", {
                                    minimumFractionDigits: 2,
                                })}
                            </div>
                        </div>

                        <Divider style={{ margin: "15px 0" }} />

                        {/* Beneficiary */}
                        <div
                            style={{
                                fontSize: 14,
                                fontWeight: 700,
                                marginBottom: 12,
                            }}
                        >
                            Beneficiary Details
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 9,
                            }}
                        >
                            <ReceiptRow
                                label="Name"
                                value={
                                    receiptData?.requestPayload?.custName ||
                                    "N/A"
                                }
                            />

                            <ReceiptRow
                                label="Account"
                                value={
                                    receiptData?.requestPayload
                                        ?.custAccountNumber || "N/A"
                                }
                            />

                            <ReceiptRow
                                label="IFSC"
                                value={
                                    receiptData?.requestPayload?.custIFSC ||
                                    "N/A"
                                }
                            />

                            <ReceiptRow
                                label="Mobile"
                                value={
                                    receiptData?.requestPayload
                                        ?.custMobileNumber || "N/A"
                                }
                            />
                        </div>

                        <Divider style={{ margin: "18px 0" }} />

                        {/* Transaction */}
                        <div
                            style={{
                                fontSize: 14,
                                fontWeight: 700,
                                marginBottom: 12,
                            }}
                        >
                            Transaction Details
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 9,
                            }}
                        >
                            <ReceiptRow
                                label="Transaction ID"
                                value={receiptData?.requestID || "N/A"}
                            />

                            <ReceiptRow
                                label="UTR"
                                value={
                                    receiptData?.responsePayload?.utr ||
                                    "N/A"
                                }
                            />

                            <ReceiptRow
                                label="Transfer Type"
                                value={
                                    receiptData?.requestPayload
                                        ?.transferType || "N/A"
                                }
                            />

                            <ReceiptRow
                                label="Date & Time"
                                value={
                                    receiptData?.createdAt
                                        ? dayjs(
                                            receiptData.createdAt
                                        ).format(
                                            "DD MMM YYYY, hh:mm A"
                                        )
                                        : "N/A"
                                }
                            />
                        </div>

                        <Divider style={{ margin: "20px 0 14px" }} />

                        <div
                            style={{
                                textAlign: "center",
                                fontSize: 11,
                                color: "#888",
                                lineHeight: 1.5,
                            }}
                        >
                            This is a computer-generated receipt.
                            <br />
                        </div>
                    </div>
                )}

                {/* Print button outside receipt */}
                <div
                    className="receipt-print-actions"
                    style={{
                        padding: "0 26px 22px",
                    }}
                >
                    <Button
                        type="primary"
                        block
                        onClick={handlePrintReceipt}
                    >
                        Print Receipt
                    </Button>
                </div>
            </Modal>

        </>
    )
}
export default Payout